export function isDevelopmentOrStaging() {
  return isDevelopment() || isStaging();
}

export function isDevelopment() {
  return import.meta.env.MODE === "development";
}

export function isStaging() {
  return import.meta.env.MODE === "staging";
}
